export function windowModal() {
    let $modal = $(".modal-window");

    $modal.each(function () {
        let $th = $(this);
        let $body = $("body");
        let closeModal = function () {
            $th.removeClass("open-modal");
            $body.removeClass("lock");
        };
        let openModal = function () {
            $th.addClass("open-modal");
            $body.addClass("lock");
        };

        if ($th.hasClass("lang-modal")) {
            let $openBtn = $(".lang-menu-opener");

            $openBtn.on("click", function () {
                openModal();
            });

            $body.on("click",".modal-window .close-btn", function () {
                closeModal();
            });
        } else {
            let $overlay = $th.find(".modal-overlay");
            let $cards = $(".our-team-item");

            $cards.on("click", function () {
                openModal();
            });

            $overlay.on("click", function () {
                closeModal();
            });

            $body.on("click",".modal-window .close-button", function () {
                closeModal();
            });
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/windowModal.js